import { formatAbbr } from '@lair-finance/util'
import { useAccount } from '@lair-finance/wagmi'
import { useResponsive } from '@/shared/hooks/useResponsive.ts'
import { Button, ButtonProps } from '@lair-finance/uikit'
import { forwardRef } from 'react'

export const ConnectedButton = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    className?: string
    focus?: boolean
    onClick?: () => void
  }
>(({ className, focus, onClick }, ref) => {
  const isTablet = useResponsive('tablet')
  const account = useAccount()
  const formattedAddress = account.address ? formatAbbr(account.address, 4) : '...'

  return (
    <Button ref={ref} variant="Outline" className={className} size={isTablet ? 'md' : 'sm'} focus={focus} onClick={onClick}>
      {formattedAddress}
    </Button>
  )
})

ConnectedButton.displayName = 'ConnectedButton'
